import React from 'react';

const TTSSkipButton = ({ isPlaying, onSkip, disabled = false }) => {
    if (!isPlaying) return null;

    return (
        <button
            onClick={onSkip}
            disabled={disabled}
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                padding: '8px 16px',
                background: disabled ? '#ccc' : '#dc3545',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: disabled ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: 'bold'
            }}
            title="Skip all speech"
        >
            <span style={{ fontSize: '12px' }}>⏭</span>
            Skip Speech
        </button>
    );
};

export default TTSSkipButton;
